<div class="users-assigned-container">
  
  <!-- Header Section -->
  <div class="header-section">
    <h1 class="page-title">Usuarios asignados</h1>
    <p class="page-subtitle">Mira la lista de tus mentoreados aquí</p>
  </div>

  <!-- Filter Section -->
  <div class="filter-section">
    <div class="filter-row">
      <div class="filter-group">
        <input type="text" class="search-input" placeholder="Buscar por nombre" [(ngModel)]="searchTerm" (input)="onSearchChange()">
        <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      </div>

      <div class="filter-group">
        <select class="filter-select" [(ngModel)]="statusFilter" (change)="onFilterChange()">
          <option value="">Filtrar estado</option>
          <option value="activo">Activo</option>
          <option value="inactivo">Inactivo</option>
          <option value="pendiente">Pendiente</option>
        </select>
        <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6,9 12,15 18,9"></polyline>
        </svg>
      </div>

      <div class="filter-group">
        <select class="filter-select" [(ngModel)]="stageFilter" (change)="onFilterChange()">
          <option value="">Filtrar etapa</option>
          <option value="iniciando-programa">Iniciando programa</option>
          <option value="análisis-profundo">Análisis profundo</option>
          <option value="mapa-de-identidad">Mapa de identidad</option>
          <option value="phoenix-session">Phoenix Session</option>
          <option value="visionboard">Visionboard</option>
          <option value="prd-1">PRD 1</option>
          <option value="plan-de-vida">Plan de vida</option>
          <option value="graduación">Graduación</option>
          <option value="programa-completado">Programa completado</option>
        </select>
        <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6,9 12,15 18,9"></polyline>
        </svg>
      </div>

      <div class="filter-group">
        <app-custom-date-picker
          [(ngModel)]="dateFromFilter" 
          (dateChange)="onFilterChange()"
          placeholder="Filtrar agenda desde">
        </app-custom-date-picker>
      </div>

      <div class="filter-group">
        <app-custom-date-picker
          [(ngModel)]="dateToFilter" 
          (dateChange)="onFilterChange()"
          placeholder="Filtrar agenda hasta">
        </app-custom-date-picker>
      </div>
    </div>
  </div>

  <!-- Users Table -->
  <div class="table-container">
    <div class="table-responsive">
      <table class="users-table">
      <thead>
        <tr>
          <th class="sortable" (click)="sortBy('name')">
            Mentoreado
            <svg class="sort-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </th>
          <th>Estado</th>
          <th>Etapa actual</th>
          <!-- <th>Tareas pendientes</th> -->
          <th>Próxima cita</th>
          <th>Progreso general</th>
          <th>Ver</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of paginatedUsers; let i = index" class="user-row">
          <td class="user-cell">
            <div class="user-info">
              <div class="user-avatar">
                <img [src]="user.avatar || '/assets/icons/default-avatar.png'" [alt]="user.name" class="avatar-img">
              </div>
              <span class="user-name">{{ user.name }}</span>
            </div>
          </td>
          <td class="status-cell">
            <div class="status-indicator" [class]="'status-' + user.status">
              <div class="status-dot"></div>
              <span class="status-text">{{ user.status | titlecase }}</span>
            </div>
          </td>
          <td class="stage-cell">{{ user.currentStage }}</td>
          <!-- <td class="tasks-cell">{{ user.pendingTasks }} tarea{{ user.pendingTasks !== 1 ? 's' : '' }} pendiente{{ user.pendingTasks !== 1 ? 's' : '' }}</td> -->
          <td class="appointment-cell">{{ user.nextAppointment }}</td>
          <td class="progress-cell">
            <div class="progress-container">
              <div class="progress-bar-container">
                <div class="progress-bar" [style.width.%]="user.progress"></div>
              </div>
              <span class="progress-text">{{ user.progress }}%</span>
            </div>
          </td>
          <td class="action-cell">
            <button class="view-button" (click)="viewUser(user)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="pagination-container" *ngIf="totalPages > 1">
      <div class="pagination-info">
        Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, filteredUsers.length) }} de {{ filteredUsers.length }} usuarios
      </div>
      <div class="pagination-controls">
        <button class="pagination-btn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15,18 9,12 15,6"></polyline>
          </svg>
          Anterior
        </button>
        
        <div class="page-numbers">
          <button 
            *ngFor="let page of getPageNumbers()" 
            class="page-number" 
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{ page }}
          </button>
        </div>
        
        <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
          Siguiente
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9,18 15,12 9,6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>